<div class="bg">
    <fury-page>
      <fury-title class="title">
        <span [@fadeInRight]>Update Service Agreement Version</span>
      </fury-title>
    </fury-page>
    <div fxLayout="column" fxLayoutAlign="start center">
      <div [@fadeInUp] class="card">
        <form [formGroup]="agreementVersionForm" style="width: 100%;">
          <div class="content" fxLayout="column" fxLayoutGap="8px">
            <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Service Agreement Version</mat-label>
                <input type="number" matInput placeholder="Service Agreement Version" min="0" formControlName="serviceAgreementVersion" (keypress)="apiService.allowNumbers($event)">
                <mat-error
                  *ngIf="agreementVersionForm.controls['serviceAgreementVersion'].touched && agreementVersionForm.controls['serviceAgreementVersion'].hasError('required')">
                  This is a required field.</mat-error>
              </mat-form-field>
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Version Updated Date</mat-label>
                <input matInput formControlName="versionUpdated" [min]="agreementVersionDetails?.versionUpdated" [matDatepicker]="picker" (click)="picker.open()" [readonly]="true">
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error
                *ngIf="agreementVersionForm.controls['versionUpdated'].touched && agreementVersionForm.controls['versionUpdated'].hasError('required')">
                This is a required field.</mat-error>
              </mat-form-field>
            </div>
           </div>
            
          <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
            <button mat-button type="button" class="sub-button" (click)="update()">Update</button>
          </div>
          </form>
      </div>
    </div>
  </div>
  
  
  

